import { c as _c } from "react/compiler-runtime";
import { useOptimizely } from '@libs/common-next';
import { docs } from '../config';
import css from './actions.module.scss';
export function Actions() {
  const $ = _c(4);
  const {
    instance
  } = useOptimizely();
  let t0;
  if ($[0] !== instance) {
    t0 = docs.actions(instance?.getProjectConfig()).map(_temp);
    $[0] = instance;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(action) {
  return <div key={action.title} className={css.action}><div><p>{action.title}</p><span>{action.subtitle}</span></div>{action.action.url ? <a target="_blank" href={action.action.url} className={css.button}>{action.action.text}</a> : <span className={css.env}>{action.action.text}</span>}<span className={css.description}>{action.description}</span></div>;
}